import React, { useEffect, useState } from 'react';
import { ChartsDataCountSerieCampanha } from '../../config/api';
import { getCountingColor, statusOrder, convertStatusName, statusOrderTranslated, getPlotlyPlot } from './ChartsUtils';
import ReactResizeDetector from 'react-resize-detector';

var state;
var jsx = null;

const Sunburstly = (props) => {
    //Get localized reac-plotly plot
    const Plot = getPlotlyPlot();

    const [data, setData] = useState([]);
    const [siz, setSiz] = useState({});

    const [forceupdate, setForceUpdate] = useState({});

    const graph = (props) => {
        if (!state || forceupdate) {
            state = getNewPlot(props);
            setForceUpdate(false);
            jsx = null;
        }
        return getOldPlot(state);
    }

    function getNewPlot(props) {
        return (
            {
                data: data,
                layout: {
                    width: siz.width,
                    height: siz.height,
                    showlegend: true,
                    legend: { orientation: 'h', xanchor: 'center', yanchor: 'top' },
                    margin: { l: 4, r: 4, b: 0, t: 4, pad: 0 }
                },
                config: {
                    locale: "pt-BR",
                    displaylogo: false,
                    displayModeBar: false,
                    modeBarButtonsToRemove: ['sendDataToCloud', 'hoverCompareCartesian', 'hoverClosestCartesian', 'lasso2d', 'select2d', 'autoScale2d']
                }
            }
        );
    }

    function getOldPlot(props) {
        if (!jsx) {
            jsx = (
                <Plot
                    data={state.data}
                    layout={state.layout}
                    config={state.config}
                />
            );
        }
        return jsx;
    }

    function formatData(data) {
        var labels = [];
        var parents = [];
        var values = [];
        var colors = [];

        var datum = [];
        var map = {};

        data.forEach(el => {
            var limit;
            var separator;
            if (el.status === statusOrder[2]) {
                limit = el.limiteQuantificacaoSuperior
                separator = ' > '
            }
            else if (el.status === statusOrder[0]) {
                limit = el.limiteQuantificacaoInferior
                separator = ' < '
            }
            else {
                limit = ''
                separator = ''
            }
            var key = el.status + separator + limit;
            if (key in map) {
                map[key][el.serie] = el.counter
            }
            else {
                var serieCampanha = {};
                serieCampanha[el.serie] = el.counter;
                map[key] = serieCampanha;
            }
        });

        Object.keys(map).forEach(el => {
            var obj = {};
            obj['campanha'] = [];
            obj['valores'] = [];
            obj['nomeSerie'] = convertStatusName(el);

            Object.keys(map[el]).forEach(e => {
                obj['campanha'].push(e);
                obj['valores'].push(map[el][e]);
            });

            datum.push(obj);
        });

        function adjustParents(value, parent) {
            let parentIndex = labels.indexOf(parent);
            values[parentIndex] += value;
            if (parents[parentIndex] !== "") adjustParents(value, parents[parentIndex]);
        }

        datum.forEach(e => {
            var sep = e.nomeSerie.split(' ');
            var stat = sep[0];
            if (!labels.includes(stat)) {
                labels.push(stat);
                parents.push("");
                values.push(0);
                colors.push(getCountingColor(stat));
            }

            if (stat !== statusOrderTranslated[1]) {
                labels.push(e.nomeSerie);
                parents.push(stat);
                values.push(0);
                colors.push(getCountingColor(stat));
                for (let i = 0; i < e.campanha.length; i++) {
                    labels.push(e.nomeSerie + " - " + e.campanha[i]);
                    parents.push(e.nomeSerie);
                    values.push(e.valores[i]);
                    colors.push(getCountingColor(stat));
                    adjustParents(e.valores[i], e.nomeSerie);
                }
            } else {
                for (let i = 0; i < e.campanha.length; i++) {
                    labels.push(e.nomeSerie + " - " + e.campanha[i]);
                    parents.push(stat);
                    values.push(e.valores[i]);
                    colors.push(getCountingColor(stat));
                    adjustParents(e.valores[i], e.nomeSerie);
                }
            }

        })
        var ret = { lbls: labels, prts: parents, vls: values, clrs: colors };
        return ret;
    }

    useEffect(() => {
        (async () => {

            if (!props.parametroSerie) return
            const data = formatData(await ChartsDataCountSerieCampanha(props.parametroSerie.parametro, props.parametroSerie.seriesHabilitadas))

            let dat = [{
                type: "sunburst",
                labels: data.lbls,
                parents: data.prts,
                values: data.vls,
                branchvalues: 'total',
                outsidetextfont: { size: 20, color: "#377eb8" },
                leaf: { opacity: 0.4 },
                marker: { line: { width: 2 }, colors: data.clrs }
            }];

            setData(dat);
            setForceUpdate(true);
        })()
    }, [props.parametroSerie])

    const onResize = (width, height) => {
        setSiz({ width: width, height: height });
        setForceUpdate(true);
    }

    return (
        <div style={{ position: "absolute", width: "98%", height: "94%" }}>
            {graph(props)}
            <ReactResizeDetector handleWidth handleHeight onResize={onResize} />
        </div>
    );

}

export default Sunburstly;